import { useState } from "react"
import axios from "../api/axios"
//import '../Composants/utilitaires/style.css'
import Navbar from '../Composants/utilitaires/Barmenu'
import Piedpage from "../Composants/utilitaires/Piedpage"
import {register} from "../Composants/Pages/auth"
import {useNavigate,Link} from 'react-router-dom'
function Register(){
    const [isLoading,setIsLoading]=useState(false)
    const [err,setErr]=useState("")
    const [nom,setNom]=useState("")
    const [postnom,setPostnom]=useState("")
    const [prenom,setPrenom]=useState("")
    const [sexe,setSexe]=useState("")
    const [etatcivil,setEtatcivil]=useState("")
    const[adresse,setAdresse]=useState("")
    const[telephone,setTelephone]=useState("")
    const[lieu_naissance,setLieunaissance]=useState("")
    const[date_naissance,setDatenaissance]=useState("")
    const[email,setEmail]=useState("")
    const[name,setName]=useState("")
    const[password,setPassword]=useState("")
    const [password_confirmation,setPasswordConfirmation]=useState("")
    const navigate=useNavigate()
    const type="Admin"
    const [step, setStep] = useState(1);

    // Fonctions de navigation
    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);
    const Handlesubmit=async()=>{
        setIsLoading(true)
        await axios.post('api/addminecol',{nom,postnom,prenom,sexe,adresse,etatcivil,telephone,lieu_naissance,date_naissance,email,name,password,password_confirmation,type}).then((res)=>{
            setIsLoading(false) 

            if(res.status===200){
                    navigate('/connexion',{replace:true})
               }
            }).catch((err)=>{
                setIsLoading(false)
               if(err?.response && err?.response?.status===422){
                setErr(err.response.data.errors)
               }
            })
        
        

        
    }
    const canGoNext = () => {
    if (step === 1) {
        // Retourne vrai si Nom, Postnom et Sexe sont remplis
        return nom.trim() !== '' && postnom.trim() !== '' && sexe !== '';
    }
    if (step === 2) {
        // Retourne vrai si Adresse, Téléphone et État-civil sont remplis
        return adresse.trim() !== '' && telephone !== '' && etatcivil !== '';
    }
    if (step === 3) {
        // Retourne vrai si Email, Identifiant et les deux mots de passe correspondent
        return email.trim() !== '' && name.trim() !== '' && password !== '' && password === password_confirmation;
    }
    return false;
};
// Fonction pour le bouton "Suivant"
const handleNext = () => {
    if (canGoNext()) {
        setStep(step + 1);
    } else {
        alert("Veuillez remplir tous les champs obligatoires avant de continuer.");
        // Optionnel : vous pouvez aussi déclencher vos messages d'erreurs (err) ici
    }
};
    return(
        <>
            <div className="bg-primary py-3 px-4 shadow-sm">
                <Link to="/" className="text-white text-decoration-none fw-bold">← Accueil</Link>
            </div>

            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="card shadow border-0 p-4 p-md-5">
                            <h3 className="text-center fw-bold mb-4">Inscription - Étape {step}/3</h3>
                            
                            {/* Barre de progression */}
                            <div className="progress mb-5" style={{ height: '8px' }}>
                                <div className={`progress-bar bg-success w-${step === 1 ? '33' : step === 2 ? '66' : '100'}`} />
                            </div>

                            <form>
                                {/* ÉTAPE 1 : Identité de base */}
                                {step === 1 && (
                                    <div className="row g-3 animate__animated animate__fadeIn">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Nom</label>
                                            <input type="text" className="form-control form-control-lg" placeholder="Faustin" value={nom} onChange={(e)=>setNom(e.target.value)} />
                                            {err?.nom && <small className='text-danger'>{err?.nom[0]}</small>}
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Postnom</label>
                                            <input type="text" className="form-control form-control-lg" placeholder="Makasi" value={postnom} onChange={(e)=>setPostnom(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Prénom</label>
                                            <input type="text" className="form-control form-control-lg" placeholder="Faustin" value={prenom} onChange={(e)=>setPrenom(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Genre</label>
                                            <select className="form-select form-control-lg" value={sexe} onChange={(e)=>setSexe(e.target.value)}>
                                                <option value="" disabled>Choix du genre</option>
                                                <option value="M">Homme</option>
                                                <option value="F">Femme</option>
                                            </select>
                                        </div>
                                    </div>
                                )}

                                {/* ÉTAPE 2 : Informations personnelles */}
                                {step === 2 && (
                                    <div className="row g-3 animate__animated animate__fadeIn">
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Adresse</label>
                                            <input type="text" className="form-control form-control-lg" placeholder="Votre adresse" value={adresse} onChange={(e)=>setAdresse(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">État-civil</label>
                                            <select className="form-select form-control-lg" value={etatcivil} onChange={(e)=>setEtatcivil(e.target.value)}>
                                                <option value="" disabled>Choix de l'état civil</option>
                                                <option value="Célibataire">Célibataire</option>
                                                <option value="Marié(e)">Marié(e)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Téléphone</label>
                                            <input type="number" className="form-control form-control-lg" placeholder="243..." value={telephone} onChange={(e)=>setTelephone(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Lieu de naissance</label>
                                            <input type="text" className="form-control form-control-lg" value={lieu_naissance} onChange={(e)=>setLieunaissance(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Date de naissance</label>
                                            <input type="date" className="form-control form-control-lg" value={date_naissance} onChange={(e)=>setDatenaissance(e.target.value)} />
                                        </div>
                                    </div>
                                )}

                                {/* ÉTAPE 3 : Sécurité & Identifiants */}
                                {step === 3 && (
                                    <div className="row g-3 animate__animated animate__fadeIn">
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Nom d'utilisateur</label>
                                            <input type="text" className="form-control form-control-lg" placeholder="faustinmakasi" value={name} onChange={(e)=>setName(e.target.value)} />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Email</label>
                                            <input type="email" className="form-control form-control-lg" placeholder="exemple@mail.com" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Mot de passe</label>
                                            <input type="password" className="form-control form-control-lg" onChange={(e)=>setPassword(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Confirmer mot de passe</label>
                                            <input type="password" className="form-control form-control-lg" onChange={(e)=>setPasswordConfirmation(e.target.value)} />
                                        </div>
                                    </div>
                                )}

                               {/* BOUTONS DE NAVIGATION */}
                                    <div className="d-flex justify-content-between mt-5">
                                        {step > 1 && (
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-secondary px-4" 
                                                onClick={prevStep}
                                            >
                                                Précédent
                                            </button>
                                        )}
                                        
                                        {step < 3 ? (
                                            <button 
                                                type="button" 
                                                className={`btn px-5 py-2 ms-auto ${canGoNext() ? 'btn-primary' : 'btn-secondary disabled'}`} 
                                                onClick={handleNext}
                                                disabled={!canGoNext()} // Bloque le clic au niveau du navigateur
                                            >
                                                Suivant
                                            </button>
                                        ) : (
                                            <button 
                                                type="button" 
                                                className="btn btn-success ms-auto px-5 py-2 fw-bold" 
                                                onClick={Handlesubmit} 
                                                disabled={isLoading || !canGoNext()} // Bloque l'envoi final si invalide
                                            >
                                                {isLoading ? "Inscription..." : "S'inscrire"}
                                            </button>
                                        )}
                                    </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Piedpage />
        </>
    )
}
export default Register